export const ContactBlock = {
  name: "Contact",
  nameI18n: "builder_ui.block_category.contact",
} as const;

export const CallToActionBlock = {
  name: "Call to Action",
  nameI18n: "builder_ui.block_category.cta",
} as const;

export const ContentBlock = {
  name: "Content",
  nameI18n: "builder_ui.block_category.content",
} as const;

export const LayoutBlock = {
  name: "Layout",
  nameI18n: "builder_ui.block_category.layout",
} as const;

export const TemplateBlock = {
  name: "Template",
  nameI18n: "builder_ui.block_category.template",
} as const;

export const SectionsBlock = {
  name: "Sections",
  nameI18n: "builder_ui.block_category.sections",
} as const;

export const GalleryBlock = {
  name: "Gallery",
  nameI18n: "builder_ui.block_category.gallery",
} as const;

export const BasicBlock = {
  name: "Basic",
  nameI18n: "builder_ui.block_category.basic",
} as const;

export const HeroHeadersBlock = {
  name: "Hero Headers",
  nameI18n: "builder_ui.block_category.hero",
} as const;

export const HomepageBlock = {
  name: "Homepage",
  nameI18n: "builder_ui.block_category.homepage",
} as const;

export const SalesBlock = {
  name: "Sales",
  nameI18n: "builder_ui.block_category.sales",
} as const;

export const AboutUsBlock = {
  name: "About Us",
  nameI18n: "builder_ui.block_category.about_us",
} as const;

export const PricingBlock = {
  name: "Pricing",
  nameI18n: "builder_ui.block_category.pricing",
} as const;

export const OtherBlock = {
  name: "Other",
  nameI18n: "builder_ui.block_category.other",
} as const;

export const ButtonsBlock = {
  name: "Buttons",
  nameI18n: "builder_ui.block_category.buttons",
} as const;

export const MediaBlock = {
  name: "Media",
  nameI18n: "builder_ui.block_category.media",
} as const;

export const FeatureCardBlock = {
  name: "Feature Card",
  nameI18n: "builder_ui.block_category.feature_card",
} as const;

export const TestimonialsBlock = {
  name: "Testimonials",
  nameI18n: "builder_ui.block_category.testimonials",
} as const;

export const TextBlock = {
  name: "Text",
  nameI18n: "builder_ui.block_category.text",
} as const;

export const ActionsBlock = {
  name: "Actions",
  nameI18n: "builder_ui.block_category.actions",
} as const;

export const AllCategories = [
  AboutUsBlock,
  ActionsBlock,
  BasicBlock,
  ButtonsBlock,
  CallToActionBlock,
  ContactBlock,
  ContentBlock,
  GalleryBlock,
  HeroHeadersBlock,
  HomepageBlock,
  LayoutBlock,
  MediaBlock,
  OtherBlock,
  SectionsBlock,
  TemplateBlock,
  FeatureCardBlock,
  SalesBlock,
  PricingBlock,
  TestimonialsBlock,
  TextBlock,
] as const;

export const AllCategoryNames = AllCategories.map(category => category.name);

export type BlockCategoryName = (typeof AllCategoryNames)[number];
